<div class="mobile-menu" id="mobile-menu" data-menu hidden{{{ root }}}>
  <nav aria-label="Mobil bölümler">
    <ol class="mobile-menu-list">
{{#each items}}
      <li{{{ edit }}}><a href="{{ href }}"><em{{{ label.attrs }}}>{{{ label.html }}}</em></a></li>
{{/each}}
    </ol>
  </nav>
  <p class="mobile-menu-foot"{{{ location.attrs }}}>{{{ location.html }}}</p>
</div>
